/**
 * Content type for classification
 */
export enum ContentType {
  TEXT = 'text',
  IMAGE = 'image',
  AUDIO = 'audio',
  MIXED = 'mixed',
}
